<template>
  <div class="mt-3 mb-4">
    <a class="ie-share-btn" style="background-color: #4267b2;" :href="facebookUrl" target="_blank" @click="shareFacebook">
      <span style="font-weight: 500; letter-spacing: 0.05em;">Share</span>
      <span class="icon icon-facebook ml-2" style="color: #fff;"></span>
    </a>
    <a class="ie-share-btn" style="background-color: #38A1F3;" :href="url" target="_blank" @click="shareTwitter">
      <span style="font-weight: 500; letter-spacing: 0.05em;">Tweet</span>
      <span class="icon icon-twitter ml-2" style="color: #fff;"></span>
    </a>
  </div>
</template>

<script>
const props = {
  mode: {
    type: String,
    required: true
  },
  url: {
    type: String,
    required: true
  },
  shareText: {
    type: String,
    required: true
  }
}

const computed = {
  facebookUrl () {
    const url = encodeURIComponent(this.url)
    return `https://www.facebook.com/dialog/feed?app_id=579277375807758&display=popup&caption=test&link=${url}`
  }
}

const methods = {
  shareWindow (title, url) {
    const y = (window.outerHeight / 2) - 200
    const x = (window.outerWidth / 2) - 300
    window.open(url, title, `width=600,height=400,left=${x},top=${y}`)
  },
  shareFacebook (e) {
    e.preventDefault()
    const url = encodeURIComponent(this.url)
    this.shareWindow('Facebook', `https://www.facebook.com/dialog/feed?app_id=579277375807758&display=popup&caption=test&link=${url}`)
  },
  shareTwitter (e) {
    e.preventDefault()
    const url = encodeURIComponent(this.url)
    const text = encodeURIComponent(this.shareText)
    this.shareWindow('Twitter', `https://twitter.com/intent/tweet?&original_referer=${url}&text=${text}&tw_p=tweetbutton&url=${url}`)
  }
}

export default {
  props,
  computed,
  methods
}
</script>

<style>
.ie-share-btn {
  color: #fff;
  padding: 15px 20px;
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/calculator/ExpenditureShare.vue